<div [style.display]="display ? 'block' : 'none'">
    <div class="chart-container">
        <div class="discount-label font-color-grey" [style.left.px]="chartAreaLeft">
            {{ 'D39' | translate: locale }} %
        </div>

        <div [style.height.px]="canvas.height" [style.width.px]="canvas.width" class="history-chart-container">
            <canvas class="history-chart"></canvas>
        </div>

        <div class="slider-container" [style.height.px]="chartAreaHeight"
            [style.left.px]="sliderContainerLeft - sliderBorderWidth" [style.top.px]="chartAreaTop"
            [style.width.px]="sliderContainerWidth + sliderBorderWidth">
            <input class="slider" type="range" (change)="onChange(+slider.value)" [min]="sliderRange.min"
                [max]="sliderRange.max" [value]="sliderDefaultValue"
                [style.--slider-border-width.px]="sliderBorderWidth" [style.--slider-height.px]="sliderHeight"
                [style.--slider-width.px]="sliderWidth" [style.--slider-grey-arrow-width.px]="sliderGreyArrowWidth"
                #slider>
        </div>
    </div>
</div>